import template from './mobile-single-search.pug';

export const MobileSingleSearchComponent = {
  template,
  bindings: {
    column: '<?',
    applyFilter: '&',
    moduleName: '@?',
  },
  transclude: true,
  controller: class MobileSingleSearchComponent {
    constructor() {
      'ngInject';
      this.model = null;
      this.model2 = null;
      this.filter = {};
    }

    $onInit() {
      this.module = this.moduleName || this.column.fieldType;
      this.setModuleParams();
    }

    setModuleParams() {
      switch (this.module) {
        case 'connected_record':
          this.moduleType = 'connected_record';
          this.moduleParams = {
            fieldKey: this.column.filter.name,
          }
          break;
        case 'radio':
        case 'multiselect':
          this.moduleType = 'multiselect';
          let valueField = 'id';
          let labelField = 'labelField';
          if (this.column.filter.selectOptions.length > 0) {
            if ('value' in this.column.filter.selectOptions[0]) {
              valueField = 'value';
            }
            if ('name' in this.column.filter.selectOptions[0]) {
              labelField = 'name';
            }
          }
          this.moduleParams = {
            fieldKey: this.column.filter.name,
            selectOptions: this.column.filter.selectOptions,
            selectConfig: {
              labelField: labelField,
              valueField: valueField,
              searchField: 'name',
              maxItems: this.module === 'radio' ? 1 : undefined,
            },
          };
          break;
        case 'date':
          this.moduleType = 'date';
        case 'integer':
          if (!this.moduleType) this.moduleType = 'integer';
          const filters = this.column.filters.map((filter) => filter);
          this.moduleParams = {
            fieldKey: this.column.filters[0].name,
            fieldKey2: this.column.filters[1].name,
            placeholder: this.column.filters[0].placeholder,
            placeholder2: this.column.filters[1].placeholder,
          };
          break;
        case 'string':
        case 'phone':
        case 'location':
          this.moduleType = 'string';
          this.moduleParams = {
            fieldKey: this.column.filter.name,
          };
          break;
        case 'full':
          this.moduleType = 'string';
          this.moduleParams = {
            fieldKey: 'full_search',
          };
          break;
      }
    }

    removeFilter(key) {
      this.edit(null, key);
      this.model = '';
    }

    removeRangeFilter() {
      this.model = '';
      this.model2 = '';
      this.filter[this.moduleParams.fieldKey] = null;
      this.filter[this.moduleParams.fieldKey2] = null;
      this.applyFilter({
        $event: { filter: this.filter },
      });
    }

    edit(value, key = this.column?.filter?.name) {
      if (!key) return;
      this.filter[key] = value;
      this.applyFilter({
        $event: { filter: this.filter },
      });
    }
  },
};
